<template>
  <LoginHolder>
    <AlertMessage :alerMessage="alerMessage"></AlertMessage>
    <AlertMessageSuccess :alerMessage="alerMessageSuccess"></AlertMessageSuccess>
    <h2 class="mb-1">Forgot Password</h2>
    <p class="pb-3">A new password will be sent to the registered email.</p>

    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <form
        ma-8
        v-on:submit.prevent>
        <ValidationProvider v-slot="{ errors }" name="Email Address" rules="required">
          <v-text-field
            v-model="user.email"
            maxlength="100"
            :error-messages="errors"
            label="Enter your email address"
            required
            :disabled="loading"
          ></v-text-field>
        </ValidationProvider>
        <v-btn class="d-none" @click="reset"></v-btn>
      </form>
    </ValidationObserver>
    <v-btn
      depressed
      block
      rounded
      large
      color="primary"
      class="mb-8 mt-6"
      @click="send()"
      :disabled="loading"
    >
      {{ loading ? 'Please wait...' : 'Reset Password' }}
    </v-btn>



    <v-btn
      depressed
      block
      rounded
      large
      :to="{ name: 'login' }"
    >
      Login
    </v-btn>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </LoginHolder>
</template>

<script>
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import LoginHolder from './LoginHolder.vue'
  import AlertMessage from '@/components/AlertMessage.vue'
  import AlertMessageSuccess from '@/components/AlertMessageSuccess.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  export default {
    name: 'ForgotPassword',
    data: () => ({
      passShow: false,
      user: {
        email: ''
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      alerMessageSuccess:{
        show: false,
        omitMessage: '',
        message: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      loading: false
    }),
    computed: {
    },
    methods: {
      async send(){
        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true
        let self = this
        this.alerMessageSuccess.message = ''
        this.alerMessageSuccess.show = false

        this.$http.secured.post('/users/forgot-password', this.user)
          .then(response => {
            this.alerMessageSuccess.message = response.data.message
            this.alerMessageSuccess.show = true
            this.clear()
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      clear () {
        Object.keys(this.user).forEach(key => {
          this.user[key] = ''
        })

        this.$refs.observer.reset()
      },
    },
    mounted() {
    },
    components: {
      SnackBar,
      ValidationProvider,
      ValidationObserver,
      LoginHolder,
      AlertMessage,
      AlertMessageSuccess
    },
  }
</script>
